<template>
	<div class="adsModel" @click="handleClickBjEve">
		<!-- 地址修改/新增 -->
		
		<!-- 内容弹窗 -->
		<div class="adCttBox" @click.stop="">
			<!-- 标题行 -->
			<ul class="adCttBox-titLine d-rn d-aic d-jcb">
				<li>
					{{pageType==1?'创建地址':'编辑地址'}}
				</li>
				<li class="showHand" @click="handleCloseAddress">
					<img src="../assets/img/comm/icon_cha.png" >
				</li>
			</ul>
			<!-- 提示行 -->
			<ul class="adCttBox-tipsLine" >
				{{pageType==1?'新增收货地址':'编辑收货地址'}}
			</ul>
			<!-- 信息模块 -->
			<div class="boxNoYs adCttBox-addInfoBox">
				<!-- 标题行 -->
				<ul class="adCttBox-addInfoBox-titBoxLine d-rn d-aic d-jcs">
					<p>当前配送至</p>
					<p>中国大陆</p>
				</ul>
				<!-- 地址信息 -->
				<ul class="adCttBox-addInfoBox-adsInfoBox d-rn d-aic d-jcs">
					<!-- 左 标题 120-->
					<p class="adCttBox-addInfoBox-adsInfoBox-lffBox d-rn d-ais d-jcc">
						<span>*</span>
						地址信息
					</p>
					<!-- 右  选择框 -->
					<li class="adCttBox-addInfoBox-adsInfoBox-rttBox d-rn d-aic d-jcb"
					@click="pickerVisible = true">
						<!-- 左 -->
						<p class="adCttBox-addInfoBox-adsInfoBox-rttBox-lffBox  one-txt-cut"
						:style="{color:addressTxt?'#666':'#999'}">
							{{addressTxt?addressTxt:'请选择省/市/区'}}
						</p>
						<!-- 右 -->
						<p class="adCttBox-addInfoBox-adsInfoBox-rttBox-rttBox">
							<img src="../assets/img/comm/icon_btmSelImg.png" >
						</p>
					</li>
				</ul>
				<!-- 详细地址 -->
				<ul class="adCttBox-addInfoBox-adsInfoBox d-rn d-aic d-jcs">
					<!-- 左 标题 120-->
					<p class="adCttBox-addInfoBox-adsInfoBox-lffBox d-rn d-ais d-jcc">
						<span>*</span>
						详细地址
					</p>
					<!-- 右=== -->
					<textarea placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息" class="adCttBox-addInfoBox-adsInfoBox-txtAeaBox" rows="" cols="" v-model="detailAdsTxt"></textarea>
				</ul>
				<!-- 公司名称 -->
				<ul class="adCttBox-addInfoBox-adsInfoBox d-rn d-aic d-jcs">
					<!-- 左 标题 120-->
					<p class="adCttBox-addInfoBox-adsInfoBox-lffBox d-rn d-ais d-jcc">
						<span>*</span>
						公司名称
					</p>
					<!-- 右==公司名称 -->
					<input type="text" v-model="companyName" class="adCttBox-addInfoBox-adsInfoBox-gsName" placeholder="请输入公司名称"  />
				</ul>
				<!-- 收货人姓名 -->
				<ul class="adCttBox-addInfoBox-adsInfoBox d-rn d-aic d-jcs">
					<!-- 左 标题 120-->
					<p class="adCttBox-addInfoBox-adsInfoBox-lffBox d-rn d-ais d-jcc">
						<span>*</span>
						收货人姓名
					</p>
					<!-- 右==公司名称 -->
					<input type="text" v-model="ReceivingName" class="adCttBox-addInfoBox-adsInfoBox-gsName" placeholder="长度不超过25字符"
					  maxlength="25"/>
				</ul>
				<!-- 手机号码 -->
				<ul class="adCttBox-addInfoBox-adsInfoBox d-rn d-aic d-jcs">
					<!-- 左 标题 120-->
					<p class="adCttBox-addInfoBox-adsInfoBox-lffBox d-rn d-ais d-jcc">
						<span>*</span>
						手机号码
					</p>
					<!-- 右==手机号码 -->
					<input type="number" v-model="userPhone" class="adCttBox-addInfoBox-adsInfoBox-gsName" placeholder="请输入手机号码"
					  oninput="if(value.length>11)value=value.slice(0,11)"/>
				</ul>
				
				<!-- 默认地址设置 -->
				<ul class="adCttBox-addInfoBox-mrAddress d-rn d-aic d-jcs">
					<img class="showHand" @click="isDefaultAds=!isDefaultAds" v-show="isDefaultAds" src="../assets/img/comm/selectedAll.png" >
					<img class="showHand" @click="isDefaultAds=!isDefaultAds" v-show="!isDefaultAds" src="../assets/img/comm/selectAll.png" >
					<p>设置为默认收货地址</p>
				</ul>
				<!-- 保存按钮 -->
				<ul class="adCttBox-addInfoBox-btmBtnBox showHand"
				@click="handlePreseInfo">
					保存
				</ul>
			</div>
		</div>
		
		
		<!-- 地址选择 -->
		<VuePicker :data="pickData" :layer="3" :showToolbar="true" @cancel="cancel" @confirm="confirm"
		:visible.sync="pickerVisible" />
	</div>
</template>

<script>
	import { addAppCAddress,upAppCAddress } from '@/api/address.js'
	import VuePicker from 'vue-pickers'
	import cityData from 'vue-pickers/city-data.js'
	const deepFreeze = function(obj) {
		var propNames = Object.getOwnPropertyNames(obj);
		propNames.forEach(function(name) {
			var prop = obj[name];
			if (typeof prop == 'object' && prop !== null) {
				deepFreeze(prop);
			}
		})
		return Object.freeze(obj)
	}
	// 冻结以提升性能
	const freezeCityData = deepFreeze(cityData)
	let _self;
	export default {
		name:"",
		data() {
			return {
				// 用户信息
				userInfo:null,
				// 修改的地址ID
				editAdsId:null,
				// 是否为默认地址
				isDefaultAds:false,
				// 电话
				userPhone:null,
				// 收货人姓名
				ReceivingName:null,
				// 公司名称
				companyName:null,
				// 详细地址
				detailAdsTxt:null,
				// 省市区拼接好字符串
				addressTxt:null,
				// 省
				shengTxt:null,
				// 市
				shiTxt:null,
				// 区
				quTxt:null,
				// 省市区数组格式
				selAddressArr:null,
				showToolbar: true,
				pickerVisible: false,
				pickData: freezeCityData,
				result: '',
			}
		},
		props:{
			// 页面属性===1新增2修改
			pageType:{
				type:[String,Number],
				default:1
			},
		},
		beforeCreate() {
			_self = this;
		},
		created() {
			// 用户信息处理===用户信息传递
			_self.userInfo=this.getUInfo();
			// 事件监听
			_self.handleAllEveAggregate();
		},
		// 方法集
		methods: {
			// 事件监听
			handleAllEveAggregate(){
				// 接口修改地址的===地址信息
				_self.$EventBus.$on('adsEditInfo',res=>{
					// 定义修改的信息
					// console.log('收到值===当前为修改',res);
					
					// 是否为默认地址
					_self.isDefaultAds=res.addr_status==2?true:false;
					// 定义地址id
					_self.editAdsId=res.addr_id;
					// 定义省市区===直接传
					_self.shengTxt=res.addr_province;
					_self.shiTxt=res.addr_market;
					_self.quTxt=res.addr_county;
					// 省市区
					_self.addressTxt=res.addr_province+res.addr_market+res.addr_county;
					// 详细地址
					_self.detailAdsTxt=res.addr_address;
					// 公司名称
					_self.companyName=res.addr_company;
					// 收货人姓名
					_self.ReceivingName=res.addr_name;
					// 手机号
					_self.userPhone=res.addr_phone;
				})
			},
			// 关闭地址弹窗
			handleCloseAddress(){
				// 清除输入的信息
				// 是否为默认地址
				_self.isDefaultAds=false;
				// 省市区
				_self.addressTxt=null;
				// 详细地址
				_self.detailAdsTxt=null;
				// 公司名称
				_self.companyName=null;
				// 收货人姓名
				_self.ReceivingName=null;
				// 手机号
				_self.userPhone=null;
				
				// 关闭地址选择器
				_self.pickerVisible=false;
				// 传递信息关闭弹窗
				_self.$EventBus.$emit('closeAdsPopup',false);
			},
			
			
			
			
			
			// 保存事件
			handlePreseInfo(){
				// 判断是否选择地址
				if(!_self.addressTxt || _self.selAddressArr&&!_self.selAddressArr.length){
					_self.$jgTips('请选择地址！');
					return false;
				}
				// 详细地址
				if(!_self.detailAdsTxt){
					_self.$jgTips('请输入详细地址！');
					return false;
				}
				// 公司名称
				if(!_self.companyName){
					_self.$jgTips('请输入公司名称！');
					return false;
				}
				// 收货人姓名
				if(!_self.ReceivingName){
					_self.$jgTips('请输入收货人姓名！');
					return false;
				}
				// 手机号
				if(!_self.userPhone){
					_self.$jgTips('请输入正确的手机号码！');
					return false;
				}
				// 定义接口信息
				let adsInfo={
					addrProvince:_self.shengTxt,//省
					addrMarket:_self.shiTxt,//市
					addrCounty:_self.quTxt,//区
					addrAddress:_self.detailAdsTxt,//详细地址
					addrName:_self.ReceivingName,//收货人
					addrPhone:_self.userPhone,//联系方式
					addrCompany:_self.companyName,//公司名称
					userId:_self.userInfo.userId,//用户ID
					addrStatus:_self.isDefaultAds?2:0,//默认地址
				}
				// 修改
				if(_self.pageType==2){
					// 定义修改地址的ID
					adsInfo.addrId=_self.editAdsId;
					
					// 防止频繁请求
					if(_self.requestAdsMlState){
						_self.$jgTips('正在请求中，请稍等！');
						return false;
					}
					_self.requestAdsMlState=true;
					// 修改接口
					upAppCAddress(adsInfo).then(res=>{
						if(res.code==200){
							// 提示修改成功
							_self.$message({
								message:'修改成功',
								type:'success'
							});
							// 信息传递
							_self.$EventBus.$emit('handleAdsInfoReturn',{
								info:adsInfo,
								status:2
							})
							
							// 允许再次请求
							_self.requestAdsMlState=false;
							// 关闭弹窗
							_self.handleCloseAddress();
						}
						// 允许再次请求
						_self.requestAdsMlState=false;
					})
					return false;
				}
				
				// 新增接口===流程↓
				// 防止频繁请求
				if(_self.requestAdsMlState){
					_self.$jgTips('正在请求中，请稍等！');
					return false;
				}
				_self.requestAdsMlState=true;
				// 新增接口请求
				addAppCAddress(adsInfo).then(res=>{
					if(res.code==200){
						// 提示新增成功
						_self.$message({
							message:'新增成功',
							type:'success'
						});
						// 信息传递
						_self.$EventBus.$emit('handleAdsInfoReturn',{
							info:res.data,
							status:1
						})
						
						// 允许再次请求
						_self.requestAdsMlState=false;
						// 关闭弹窗
						_self.handleCloseAddress();
					}
					// 允许再次请求
					_self.requestAdsMlState=false;
				})
			},
			// 点击背景事件
			handleClickBjEve(){
				// 关闭地址弹窗
				_self.handleCloseAddress();
			},
			
			
			
			
			// 地址选择器
			// 关闭选择器
			cancel() {
				// console.log('cancel')
				this.result = '';
				this.addssTxt = '';
			},
			// 确定事件触发
			confirm(res) {
				let obj = JSON.parse(JSON.stringify(res))
				if (obj[0].children) {
					delete obj[0].children
				}
				if (obj[1].children) {
					delete obj[1].children
				}
				if (obj[2].children) {
					delete obj[2].children
				}
				this.result = JSON.stringify(obj);
			
				// console.log('地址选择完毕====',res);
				// 定义显示数据
				let newTxt = '';
				res.forEach((item, index) => {
					newTxt = newTxt + item.label;
				})
				// 定义显示地址
				_self.addressTxt = newTxt;
				// 定义地址数组
				_self.selAddressArr=res;
				// 定义省市区
				_self.shengTxt=res[0].label;
				_self.shiTxt=res[1].label;
				_self.quTxt=res[2].label;
			},
			toCopy() {
				copy(copyText)
				this.$emit('tips')
			}
		},
		// 组件集
		components:{
			VuePicker
		},
		mounted() {
			
		},
		watch:{
			
		},
		computed:{
		
		},
		// 过滤器
		filters:{
			
		},
		// 实例销毁
		destroyed(){
			
		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			next();
		},
	}
</script>

<style lang="scss">
	/* 定位盒子 */
	.adsModel{
		width: 100Vw;
		height: 100Vh;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 210;
		background: rgba(0,0,0,0.3);
	}
	/* 内容 */
	.adCttBox{
		width: 830px;
		height: 653px;
		opacity: 1;
		background: #ffffff;
		position: absolute;
		top:50% ;
		left:50% ;
		transform: translate(-50%,-50%);
		padding: 30px 30px 0 30px;
		box-sizing: border-box;
		/* 标题行 */
		&-titLine{
			width: 100%;
			li:nth-of-type(1){
				font-size: 24px;
				font-weight: 400;
				color: #000000;
				letter-spacing: 3px;
			}
			li:nth-of-type(2){
				width: 20px;
				height: 20px;
				img{
					width: 100%;
					height: 100%;
				}
			}
		}
		/* 提示行 */
		&-tipsLine{
			width: 100%;
			margin-top: 40px;
			margin-left: 60px;
			font-size: 16px;
			font-weight: 400;
			text-align: left;
			color: #ff6e00;
			letter-spacing: 2px;
		}
		/* 填写信息模块 */
		&-addInfoBox{
			width: 620px;
			margin: 0 auto;
			box-sizing: border-box;
			margin-top: 15px;
			/* 标题行 */
			&-titBoxLine{
				width: 100%;
				background: #f1f1f1;
				padding: 12px 30px;
				box-sizing: border-box;
				p:nth-of-type(1){
					font-size: 16px;
					font-weight: 400;
					text-align: left;
					color: #999999;
					letter-spacing: 2px;
				}
				p:nth-of-type(2){
					font-size: 16px;
					font-weight: 400;
					color: #000000;
					letter-spacing: 2px;
					margin-left: 20px;
				}
				
			}
			/* 地址信息 */
			&-adsInfoBox{
				width: 100%;
				margin-top: 20px;
				/* 左 */
				&-lffBox{
					width: 120px;
					
					font-size: 16px;
					font-weight: 400;
					color:#666666;
					letter-spacing: 2px;
					span{
						font-size: 16px;
						font-weight: 400;
						color: #ff0000;
						letter-spacing: 2px;
					}
				}
				/* 右 */
				&-rttBox{
					width: 480px;
					opacity: 1;
					background: #ffffff;
					border: 1px solid #cccccc;
					border-radius: 2px;
					
					padding: 12px 15px;
					box-sizing: border-box;
					/* 左 */
					&-lffBox{
						flex: 1;
						font-size: 16px;
						font-weight: 400;
						text-align: left;
						color: #999999;
						letter-spacing: 2px;
					}
					/* 箭头 */
					&-rttBox{
						width: 14px;
						height: 8px;
						img{
							width: 100%;
							height: 100%;
						}
						
						
					}
				}
				/* 多行文本输入框 */
				&-txtAeaBox{
					width: 480px;
					opacity: 1;
					background: #ffffff;
					border: 1px solid #cccccc;
					border-radius: 2px;
					padding: 10px 15px;
					box-sizing: border-box;
					
					font-size: 16px;
					font-weight: 400;
					text-align: left;
					color: #666;
					letter-spacing: 2px;
				}
				&-txtAeaBox::-webkit-input-placeholder{
					font-size: 16px;
					font-weight: 400;
					text-align: left;
					color: #999999;
					letter-spacing: 2px;
				}
				/* 公司名称 */
				&-gsName{
					width: 480px;
					opacity: 1;
					background: #ffffff;
					border: 1px solid #cccccc;
					border-radius: 2px;
					padding: 12px 15px;
					box-sizing: border-box;
					
					font-size: 16px;
					font-weight: 400;
					text-align: left;
					color: #666;
					letter-spacing: 2px;
					
				}
				&-gsName::-webkit-input-placeholder{
					font-size: 16px;
					font-weight: 400;
					text-align: left;
					color: #999999;
					letter-spacing: 2px;
				}
			}
			/* 默认地址选择 */
			&-mrAddress{
				margin-left: 110px;
				width: 100%;
				margin-top: 20px;
				img{
					width: 24px;
					height: 24px;
				}
				p{
					margin-left: 10px;
					font-size: 16px;
					font-weight: 400;
					text-align: left;
					color: #000000;
					letter-spacing: 2px;
				}
			}
			/* 保存按钮 */
			&-btmBtnBox{
				margin-left: 110px;
				width: 100%;
				margin-top: 30px;
				
				width: 72px;
				height: 30px;
				opacity: 1;
				background: #3239ff;
				text-align: center;
				line-height: 30px;
				font-size: 14px;
				font-weight: 400;
				color: #ffffff;
				letter-spacing: 1px;
			}
		}
	}
</style>
